import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { UploadOutlined } from '@ant-design/icons';

// import { Row, Col } from 'reactstrap';

// // Local Depsimport { Upload, Button, Icon } from 'antd';

import { Card, Button, Upload, Divider } from 'antd';
import ComposeMessage from '../../components/ComposeMessage';
import FileDetector from '../../components/fileDetector';
import './ViewMessages.scss';
import Loading from '../../components/Loading'


export default class ViewMessages extends React.Component {
  static propTypes = {
    conversationMessages: PropTypes.any.isRequired,
    saveDraft: PropTypes.func.isRequired,
    activeDraft: PropTypes.string.isRequired,
    onChangeDraft: PropTypes.func.isRequired,
    deleteDraft: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    handleUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    downloadAttachments: PropTypes.func,
    downloadingAttachment: PropTypes.func.isRequired,
    beforeUpload: PropTypes.func.isRequired,
    fileList: PropTypes.any.isRequired,
    handleUploadChange: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
  };

  static defaultProps = {
    downloadAttachments: (attachmentId, message) => {
      console.log(attachmentId, message);
    },
    submitting: false,
  };

  componentDidMount() {
    this.scrollToBottom();
  }
  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
  };

  cardBuilder = conversationData => {
    const cards = conversationData.map(message => (
      <div className="card-wrapper" key={message.entryId}>
        <Card>
          <div className="sender-wrapper">
            <p>
              {message.name}, {message.sender}
            </p>
            <p style={{ fontSize: '12px' }}>{message.created}</p>
          </div>

          {ReactHtmlParser(message.entry)}
          {!Object.keys(message.attachments).includes('0') && (
            <div>
              <Divider className="attachment-divider" dashed />
              {!this.props.downloadingAttachment &&
                <FileDetector
                  attachments={message.attachments}
                  onClick={(attachmentId, attachmentName) =>
                    this.props.downloadAttachments(
                      message.entryId,
                      attachmentId,
                      attachmentName,
                    )
                  }
                />

              }
              {this.props.downloadingAttachment && <Loading text="Downloading an attachment" />}
            </div>
          )}
        </Card>
      </div>
    ));
    return cards;
  };

  render() {
    const {
      conversationMessages,
      saveDraft,
      activeDraft,
      onChangeDraft,
      deleteDraft,
      auth,
      beforeUpload,
      handleUpload,
      fileList,
      onRemove,
      onSubmit,
      handleUploadChange,
      submitting,
    } = this.props;
    console.log(fileList);
    let cards = [];
    if (conversationMessages) {
      cards = this.cardBuilder(
        conversationMessages.convoEntriesHeader.convoEntriesList,
      );
    }
    return (
      <div className="view-message">
        <div className="view-message-header">
          {conversationMessages &&
            conversationMessages.convoEntriesHeader.subject}
        </div>
        <div className="view-message-wrapper">
          {cards}

          <div
            style={{ float: 'left', clear: 'both' }}
            ref={el => {
              this.messagesEnd = el;
            }}
          />
        </div>

        <div className="card-wrapper">
          <Card>
            <ComposeMessage
              auth={auth}
              saveDraft={saveDraft}
              activeDraft={activeDraft}
              onChangeDraft={onChangeDraft}
            />
            <div className="message-actions">
              <Button
                disabled={submitting}
                type="primary"
                onClick={async () => {
                  await onSubmit();
                  this.scrollToBottom();
                }}
              >
                Submit
              </Button>
              <Button
                onClick={() => {
                  deleteDraft();
                }}
              >
                Discard
              </Button>
              <Upload
                fileList={fileList}
                beforeUpload={beforeUpload}
                customRequest={handleUpload}
                onChange={handleUploadChange}
                onRemove={onRemove}
              >
                <Button
                  style={{
                    backgroundColor: '#ff7c52',
                    color: 'white',
                    border: 'none',
                  }}
                >
                  Upload Attachments <UploadOutlined />
                </Button>
              </Upload>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ViewMessages/ViewMessages.jsx